import el from "@cypherpotato/el";
import { joinObjects } from "../util";

export function InlineButton(...args) {
    return el("button.app-button.inline",
        ...args);
}

export function Button(...args) {
    return el("button.app-button",
        ...args);
}

export function DangerButton(...args) {
    return el("button.app-button.danger",
        ...args);
}

export function PrimaryButton(...args) {
    return el("button.app-button.primary",
        ...args);
}

export function DivButton(...args) {
    return el("div.app-button",
        ...args);
}

export function ButtonRow(...args) {
    return el("div.button-row",
        ...args);
}

export function ToggleButton(...args) {
    const arg = joinObjects(...args);
    const valueState = el.state.create(arg.value || false);
    const onEvent = arg.onToggle;
    var target;

    valueState.subscribe((newValue) => {
        if (onEvent) {
            onEvent({ value: newValue, target });
        }
    });

    return el.state.listening([valueState], () =>
        el("button.app-button.check-button",
            ...args,
            {
                classList: [valueState.value && "checked"],
                $properties: {
                    value: {
                        get() {
                            return valueState.value;
                        },
                        set(value) {
                            valueState.value = value;
                        }
                    }
                },
                onClick() {
                    valueState.value = !valueState.value;
                },
                init() {
                    target = this;
                }
            }
        )
    );
}
